import React from 'react'

export const Message = ({message,type}) => {
    return (
        <p className={type}>{message}</p>
    )
}
